import {
  LayoutDashboard,
  Boxes,
  Sparkles,
  FlaskConical,
  TrendingUp,
  Store,
  Swords,
  Database,
  ConciergeBell,
  Users,
  ScrollText,
  Settings,
  Bell,
  HelpCircle,
  Gauge,
  Wand2,
  LineChart,
  Network,
  LayoutPanelLeft,
  Compass,
  Bot,
  Calculator,
  Boxes as BoxesIcon,
  Radio,
  History,
  Send,
} from "lucide-react";

export interface NavItem {
  to: string;
  label: string;
  icon: any;
  perm?: string;
  feature?: string;
  keywords?: string;
  excludeVerticals?: string[];
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

export const NAV_GROUPS: NavGroup[] = [
  {
    label: "Analytics",
    items: [
      { to: "/overview", label: "Overview", icon: LayoutDashboard, keywords: "dashboard home kpi" },
      { to: "/executive", label: "Executive KPIs", icon: Gauge, keywords: "kpi metrics gmroi turns margin shrink dead inventory executive intelligence" },
      { to: "/trends", label: "Trends", icon: TrendingUp, keywords: "trend timeline sales" },
      { to: "/stores", label: "Stores", icon: Store, keywords: "store format location" },
      { to: "/clusters", label: "Store Clusters", icon: Network, feature: "clusters", keywords: "cluster segment group demographics climate basket similarity map kmeans" },
      { to: "/competitors", label: "Competitors", icon: Swords, keywords: "benchmark rival market" },
    ],
  },
  {
    label: "Assortment",
    items: [
      { to: "/categories", label: "Categories", icon: Boxes, keywords: "category subcategory product hierarchy" },
      { to: "/services", label: "Services", icon: ConciergeBell, excludeVerticals: ["agriculture"], keywords: "service non-sku" },
    ],
  },
  {
    label: "AI Tools",
    items: [
      { to: "/copilot", label: "AI Copilot", icon: Bot, keywords: "copilot assistant chat ask question merchandising advisor discontinue underpriced grow profit promote why sales falling" },
      { to: "/twin", label: "Digital Twin", icon: BoxesIcon, feature: "digital_twin", excludeVerticals: ["agriculture"], keywords: "digital twin store virtual model predict rollout simulate before pilot per-store scenario what-if forecast" },
      { to: "/assortment", label: "AI Assortment", icon: Sparkles, keywords: "recommendation keep remove expand seasonal local premium budget test explainable sku" },
      { to: "/forecast", label: "Demand Forecast", icon: LineChart, feature: "forecast", keywords: "forecast predict demand daily weekly monthly seasonal holiday weather promotion" },
      { to: "/shelf", label: "Shelf Optimization", icon: LayoutPanelLeft, feature: "shelf", excludeVerticals: ["agriculture"], keywords: "shelf planogram facings space allocation linear feet elasticity eye level position" },
      { to: "/opportunities", label: "Opportunity Finder", icon: Compass, keywords: "opportunity gap missing premium private label cross sell bundle slow mover dead overstock understock roi" },
      { to: "/optimize", label: "AI Optimize", icon: Wand2, perm: "optimize", keywords: "ai recommend add remove" },
      { to: "/simulation", label: "Financial Simulation", icon: Calculator, feature: "simulation", keywords: "simulate financial scenario revenue profit margin inventory cash flow turns roi price promotion shelf vendor removal addition compare" },
      { to: "/whatif", label: "What-If Lab", icon: FlaskConical, perm: "whatif", feature: "whatif", keywords: "scenario simulate model" },
      { to: "/scenarios", label: "Scenario History", icon: History, keywords: "history saved scenarios compare restore reopen optimize what-if runs versions" },
    ],
  },
  {
    label: "Data",
    items: [
      { to: "/data", label: "Data & Reports", icon: Database, keywords: "upload export csv excel pdf report" },
      { to: "/live-sales", label: "POS / Live Sales", icon: Radio, feature: "pos_ingest", excludeVerticals: ["agriculture"], keywords: "pos point of sale live real time ingest api webhook stream square clover shopify toast lightspeed connect integration" },
    ],
  },
];

export const ADMIN_NAV: NavItem[] = [
  { to: "/users", label: "User Management", icon: Users, keywords: "users roles members team rbac" },
  { to: "/outreach", label: "Outreach Center", icon: Send, keywords: "outreach prospects sales letters email campaign leads market letter" },
  { to: "/audit", label: "Audit Log", icon: ScrollText, keywords: "audit history events security" },
];

export const ACCOUNT_NAV: NavItem[] = [
  { to: "/notifications", label: "Notifications", icon: Bell, keywords: "alerts messages" },
  { to: "/settings", label: "Settings", icon: Settings, keywords: "preferences profile appearance organization" },
  { to: "/help", label: "Help & Guide", icon: HelpCircle, keywords: "help guide how to use tutorial docs documentation glossary meaning chart metric explain support faq getting started" },
];

export const ROUTE_TITLES: Record<string, string> = {
  "/overview": "Overview",
  "/executive": "Executive KPIs",
  "/trends": "Trends",
  "/stores": "Stores",
  "/clusters": "Store Clusters",
  "/competitors": "Competitors",
  "/categories": "Categories",
  "/services": "Services",
  "/assortment": "AI Assortment",
  "/forecast": "Demand Forecast",
  "/shelf": "Shelf Optimization",
  "/opportunities": "Opportunity Finder",
  "/copilot": "AI Copilot",
  "/simulation": "Financial Simulation",
  "/twin": "Digital Twin",
  "/optimize": "AI Optimize",
  "/whatif": "What-If Lab",
  "/scenarios": "Scenario History",
  "/data": "Data & Reports",
  "/live-sales": "POS / Live Sales",
  "/users": "User Management",
  "/outreach": "Outreach Center",
  "/audit": "Audit Log",
  "/notifications": "Notifications",
  "/settings": "Settings",
  "/help": "Help & Guide",
  "/upgrade": "Upgrade Plan",
};
